import axiosInstance from '../config/axios.config';

/**
 * Company Registration Service
 * Handles all company-related API calls
 */
const companyService = {
    /**
     * Register a new company with owner user
     * @param {Object} formData - Registration form data
     * @returns {Promise} API response
     */
    register: async (formData) => {
        try {
            const response = await axiosInstance.post('/company/register', formData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    /**
     * Check if company name is available
     * @param {string} companyName - Company name to check
     * @returns {Promise} Availability response
     */
    checkCompanyName: async (companyName) => {
        try {
            const response = await axiosInstance.post('/company/check-name', {
                company_name: companyName
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    /**
     * Validate GST number
     * @param {string} gstNumber - GST number to validate
     * @returns {Promise} Validation response
     */
    checkGst: async (gstNumber) => {
        try {
            const response = await axiosInstance.post('/company/check-gst', {
                gst_number: gstNumber
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }
};

export default companyService;
